(function(){
  // Prevent multiple inclusions
  if (window.initVirtualSizing) return;

  function initVirtualSizing(root){
    var scope = (root && root.querySelector) ? root : document;
    if (scope.__vsInitDone) return;
    scope.__vsInitDone = true;

    var hVals = [];
    [5,6,7].forEach(function(f){
      for(var i=0;i<=11;i++) hVals.push(f+"' " + i + '"');
    });

    var wVals = [];
    for(var w=110; w<=400; w++) wVals.push(w + ' lbs');

    var VS = {
      hIdx: 8,
      wIdx: 40,
      abd: null,
      chest: null,
      sz: 40,
      fit: 'R'
    };

    function setStep(n){
      scope.querySelectorAll('#vsW .vsc').forEach(function(s){s.classList.remove('show');});
      var el = scope.querySelector('#vss'+n);
      if(el) el.classList.add('show');
      scope.querySelectorAll('#vsW .vp span').forEach(function(s,i){s.classList.toggle('on', i < n);});
    }

    function updateVisuals(){
      scope.querySelectorAll('.abd-img').forEach(function(img){
        img.style.display = (img.dataset.abd === (VS.abd || 'default')) ? 'block' : 'none';
      });
      scope.querySelectorAll('.chest-img').forEach(function(img){
        img.style.display = (img.dataset.chest === (VS.chest || 'default')) ? 'block' : 'none';
      });
    }

    function renderPick(containerId, vals, idx, onPick){
      var el = scope.querySelector('#'+containerId);
      if(!el) return;
      function build(){
        el.innerHTML = '';
        vals.forEach(function(v,i){
          var div = document.createElement('div');
          div.className = 'pks' + (i===idx ? ' active' : '');
          div.textContent = v;
          div.dataset.index = i;
          div.onclick = function(){
            idx = parseInt(this.dataset.index);
            onPick(idx);
            updateClasses();
            this.scrollIntoView({behavior:'smooth', block:'center'});
          };
          el.appendChild(div);
        });
      }
      function updateClasses(){
        el.querySelectorAll('.pks').forEach(function(p,i){
          p.classList.toggle('active', i===idx);
        });
      }
      build();
      var isScrolling;
      el.addEventListener('scroll', function(e){
        e.stopPropagation();
        clearTimeout(isScrolling);
        isScrolling = setTimeout(function(){
          var items = el.querySelectorAll('.pks');
          var containerRect = el.getBoundingClientRect();
          var center = containerRect.top + containerRect.height/2;
          var closest = null;
          var minDist = Infinity;
          items.forEach(function(item){
            var rect = item.getBoundingClientRect();
            var itemCenter = rect.top + rect.height/2;
            var dist = Math.abs(center - itemCenter);
            if(dist < minDist){
              minDist = dist;
              closest = item;
            }
          });
          if(closest){
            var newIdx = parseInt(closest.dataset.index);
            if(newIdx !== idx && !isNaN(newIdx)){
              idx = newIdx;
              onPick(newIdx);
              updateClasses();
            }
          }
        }, 50);
      }, {passive:true});
      el.addEventListener('wheel', function(e){
        var atTop = (el.scrollTop === 0);
        var atBottom = (el.scrollHeight - el.scrollTop === el.clientHeight);
        if((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)){
          e.preventDefault();
        }
        e.stopPropagation();
      });
      el.addEventListener('touchmove', function(e){ e.stopPropagation(); }, {passive:true});
      setTimeout(function(){
        var active = el.querySelector('.pks.active');
        if(active) active.scrollIntoView({block:'center'});
      }, 100);
    }

    window.vsPick = function(type, val, el){
      var row = scope.querySelector(type==='abd' ? '#vsAbdR' : '#vsChestR');
      if(!row) return;
      row.querySelectorAll('.bopt').forEach(function(o){o.classList.remove('on');});
      if(el) el.classList.add('on');
      VS[type] = val;
      updateVisuals();
    };

    window.vsCalc = function(){
      var hStr = hVals[VS.hIdx];
      var m = hStr.match(/(\d+)'\s*(\d+)/);
      var tin = m ? parseInt(m[1])*12 + parseInt(m[2]) : 68;
      var wLbs = parseInt(wVals[VS.wIdx]);
      var ch;
      if(wLbs<=135) ch=34;
      else if(wLbs<=150) ch=36;
      else if(wLbs<=165) ch=38;
      else if(wLbs<=185) ch=40;
      else if(wLbs<=205) ch=42;
      else if(wLbs<=225) ch=44;
      else if(wLbs<=245) ch=46;
      else if(wLbs<=265) ch=48;
      else if(wLbs<=285) ch=50;
      else if(wLbs<=305) ch=52;
      else if(wLbs<=325) ch=54;
      else if(wLbs<=345) ch=56;
      else if(wLbs<=365) ch=58;
      else if(wLbs<=385) ch=60;
      else ch=62;
      if(VS.chest==='wide') ch+=2;
      if(VS.abd==='full') ch+=2;
      if(VS.abd==='medium') ch+=1;
      ch = Math.max(32, Math.min(62, ch));
      if(ch % 2) ch += 1;
      var fit = tin<=68 ? 'S' : tin>=74 ? 'L' : 'R';
      VS.sz = ch; VS.fit = fit;
      var displaySz = fit==='R' ? ch : ch+fit;
      var rsz = scope.querySelector('#vsRSz');
      if(rsz) rsz.textContent = displaySz;
      var notes = {
        S:'Short fit — jacket and sleeve slightly shorter than regular.',
        R:'Regular fit — standard proportions for average heights.',
        L:'Long fit — jacket and sleeve extended for taller builds.'
      };
      var note = scope.querySelector('#vsNote');
      if(note) note.textContent = notes[fit];
      var chips = scope.querySelector('#vsChips');
      if(chips){
        chips.innerHTML = ['S','R','L'].map(function(f){
          var chipText = f==='R'? ch : ch+f;
          return '<div class="chip'+(f===fit?' on':'')+'" onclick="vsSelFit(\''+f+'\',this)">'+chipText+'</div>';
        }).join('');
      }
      setStep(3);
    };

    window.vsSelFit = function(f, el){
      VS.fit = f;
      var chips = scope.querySelectorAll('#vsChips .chip');
      chips.forEach(function(c){ c.classList.remove('on'); });
      if(el) el.classList.add('on');
      var displaySz = f==='R'? VS.sz : VS.sz+f;
      var rsz = scope.querySelector('#vsRSz');
      if(rsz) rsz.textContent = displaySz;
      var notes = {
        S:'Short fit — jacket and sleeve slightly shorter than regular.',
        R:'Regular fit — standard proportions for average heights.',
        L:'Long fit — jacket and sleeve extended for taller builds.'
      };
      var note = scope.querySelector('#vsNote');
      if(note) note.textContent = notes[f];
    };

    window.vsPickSize = function(){
      var target = VS.fit==='R' ? String(VS.sz) : VS.sz+VS.fit;
      var overlay = scope.querySelector('#virtualSizeDiv');
      if(overlay){
        overlay.classList.add('sizing-hidden');
        overlay.style.display = 'none';
      }
      var found=false;
      scope.querySelectorAll('#variantPopup .ValueOption').forEach(function(cell){
        if(found) return;
        var optVal = (cell.getAttribute('data-option-value')||'').trim();
        var sizeDiv = cell.closest('.variant-flex');
        var sizeLabel = '';
        if(sizeDiv){
          var sizeEl = sizeDiv.querySelector('.option-size');
          if(sizeEl) sizeLabel = sizeEl.textContent.trim().split(/\s/)[0];
        }
        if(sizeLabel+optVal === target && cell.style.pointerEvents !== 'none'){
          found = true;
          cell.click();
          cell.scrollIntoView({behavior:'smooth', block:'center'});
        }
      });
      if(!found){
        var msg = scope.querySelector('#variantPopup .virt_msg');
        if(msg) msg.textContent = 'Recommended: '+target+' — Select or nearest size.';
      }
    };

    // expose navigation to inline buttons
    window.vsGo = setStep;

    function updateVisualsInit(){
      renderPick('vsHP', hVals, VS.hIdx, function(i){ VS.hIdx=i; });
      renderPick('vsWP', wVals, VS.wIdx, function(i){ VS.wIdx=i; });
      updateVisuals();
      setStep(1);
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', updateVisualsInit, {once:true});
    } else {
      updateVisualsInit();
    }
  }

  window.initVirtualSizing = initVirtualSizing;

  // auto-init on full product page
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initVirtualSizing(document); });
  } else {
    initVirtualSizing(document);
  }
})();
